import StyledInput, {
  StyledInputPropsBase,
} from "@/components/common/input/styled-input";

interface IntegerStyledInputProps extends StyledInputPropsBase {
  value: number;
  onValueChanged: (value: number) => void;
  defaultValue?: number;
}

const IntegerStyledInput = (props: IntegerStyledInputProps) => {
  return (
    <StyledInput
      {...props}
      value={props.value.toString()}
      onChange={(e) => {
        if (!e.target.value) {
          props.onValueChanged(props.defaultValue ?? 0);
          return;
        }

        const number = parseInt(e.target.value);
        if (!Number.isNaN(number)) {
          props.onValueChanged(number);
        }
      }}
    />
  );
};

export default IntegerStyledInput;
